export const isClientError = (statusCode: number) =>
  statusCode >= 400 && statusCode <= 500
